// Paris hour of the nightly credits reset. Mirrored in mobile/src/features/profile/utils/forfait.ts
export const CREDITS_RESET_HOUR = 23;
